import { Box, Flex } from '@chakra-ui/react'
import ChatInterface from '../components/ChatInterface'
import DocumentList from '../components/DocumentList'

export default function Chat() {
  return (
    <Flex h="calc(100vh - 57px)">
      {/* Sidebar - Document List */}
      <Box
        w="300px"
        borderRightWidth="1px"
        borderColor="gray.200"
        bg="white"
        overflowY="auto"
      >
        <DocumentList />
      </Box>

      {/* Main Chat Area */}
      <Box flex={1} bg="gray.50">
        <ChatInterface />
      </Box>
    </Flex>
  )
}
